export { RatingComponent } from './rating.component';
export { RatingModule } from './rating.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-bootstrap/rating/index.js
// module id = 1251
// module chunks = 13